import type { Step } from "../script";

export const listening: Step[] = [
  {
    kind: "msg",
    id: "msg-07",
    tokens:
      "that's the wrap. ask me anything about the portfolio — 30 merchants, 12 months, every tc40, every alert. the panel is live too — every tile, merchant, mcc. hit r any time to replay.",
    pauseAfter: 0,
  },
  {
    kind: "listen",
    suggestions: [
      "worst mccs by vamp",
      "merchants closest to breach",
      "show me purederm",
      "recent ethoca alerts",
      "ce 3.0 suppression trend",
      "volume at risk this quarter",
    ],
  },
];
